module.exports = __webpack_public_path__ + "img/sheet_add.96eb9e76.svg";